import axios from "axios";
import Vue from "vue";

const getDefaultState = () => {
  return {
    dadosCadastrais: null,
    solicitacoes: [],
    carregando: true,
    configAnexos: [],
    racas: [],
    escolaridade: [],
    cursosAndamento: [],
    formacao: [],
  };
};

const atualizCadastralStore = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
    setDadosCadastrais(state, dados) {
      state.dadosCadastrais = dados;
    },
    setSolicitacoes(state, solics) {
      state.solicitacoes = solics;
    },
    setCarregando(state, loading) {
      state.carregando = loading;
    },
    setConfigAnexos(state, cfg) {
      state.configAnexos = cfg;
    },
    setRacas(state, value) {
      state.racas = value;
    },
    setEscolaridade(state, escolaridade) {
      state.escolaridade = escolaridade;
    },
    setCursosAndamento(state, cursosAndamento) {
      state.cursosAndamento = cursosAndamento;
    },
    setFormacao(state, formacao) {
      state.formacao = formacao;
    },
  },
  actions: {
    async getDadosCadastrais(context) {
      context.commit("setDadosCadastrais", null);
      await axios
        .get("/colaborador/atualizacao-cadastral")

        .then((res) => {
          if (res.data.success) {
            context.commit("setDadosCadastrais", res.data.data);
          } else {
            Vue.toasted.error(res.data.msg);
          }
        })
        .catch((e) => Vue.toasted.error(e));
    },
    async getSolicitacoes(context) {
      context.commit("setSolicitacoes", []);
      await axios
        .get("/colaborador/atestados", {
          params: {
            funcao: "ATESTADOS",
            categoria: 4,
          },
        })
        .then((res) => {
          if (res.data.success) {
            context.commit("setSolicitacoes", res.data.data);
          } else {
            Vue.toasted.error(res.data.msg);
          }
        })
        .catch((e) => Vue.toasted.error(e));
    },
    async getAnexosAtualiz(context) {
      context.commit("setConfigAnexos", []);
      await axios
        .get("/colaborador/atest-config", { params: { funcao: "CONSULTAR" } })
        .then((res) => {
          if (res.data.success) {
            context.commit("setConfigAnexos", res.data.data);
          } else Vue.toasted.error(res.data.msg);
        })
        .catch((e) => Vue.toasted.error(e));
    },
    async getRacas(context) {
      context.commit("setRacas", []);
      await axios
        .get("/colaborador/cutis")
        .then((res) => {
          if (res.data.success) {
            context.commit("setRacas", res.data.data);
          } else Vue.toasted.error(res.data.msg);
        })
        .catch((e) => Vue.toasted.error(e));
    },
    async getEscolaridadeAreaFormacao(context) {
      context.commit("setEscolaridade", []);
      context.commit("setCursosAndamento", []);
      context.commit("setFormacao", []);
      await axios
        .get("/colaborador/escolaridades-formacoes")
        .then((res) => {
          if (res.data.success) {
            context.commit("setEscolaridade", res.data.data.data.escolaridade);
            context.commit(
              "setCursosAndamento",
              res.data.data.data.cursosAndamento
            );
            context.commit("setFormacao", res.data.data.data.formacao);
          } else {
            Vue.toasted.error(res.data.msg);
          }
        })
        .catch((e) => Vue.toasted.error(e));
    },
  },
  getters: {
    temSolicitacaoPendente(state) {
      return state.solicitacoes.filter((s) => s.status == 2).length > 0;
    },
  },
};

export default atualizCadastralStore;
